import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import { HerracContext } from "../../App";

function TruckForm({ additionalAttributes, setAdditionalAttributes, subCategoryId }) {
  const [filteredBrands, setFilteredBrands] = useState([]);
  const [filteredModels, setFilteredModels] = useState([]);
  const [selectedBrand, setSelectedBrand] = useState("");

  const {
    fuelTypeData,
    cabinTypeData,
    transmissionTypeData
  } = useContext(HerracContext);

  // Debug logging
  useEffect(() => {
    console.log('🚚 TruckForm mounted with subCategoryId:', subCategoryId);
    console.log('📋 Current additionalAttributes:', additionalAttributes);
  }, [subCategoryId, additionalAttributes]);

  useEffect(() => {
    if (subCategoryId) {
      console.log('📦 Fetching brands for trucks...');
      axios.get(`https://api.herracim.az/api/Brand/BySubCategoryId?subCategoryId=${subCategoryId}`)
        .then(response => {
          console.log('✅ Brands loaded:', response.data.length, 'items');
          setFilteredBrands(response.data);
          setFilteredModels([]);
        })
        .catch(error => {
          console.error('❌ Error loading brands:', error);
          setFilteredBrands([]);
        });
    }
  }, [subCategoryId]);

  useEffect(() => {
    if (selectedBrand) {
      console.log('📦 Fetching models for brand:', selectedBrand);
      axios.get(`https://api.herracim.az/api/Model/ByBrandId?brandId=${selectedBrand}`)
        .then(response => {
          console.log('✅ Models loaded:', response.data.length, 'items');
          setFilteredModels(response.data);
        })
        .catch(error => {
          console.error('❌ Error loading models:', error);
          setFilteredModels([]);
        });
    }
  }, [selectedBrand]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    console.log(`🔧 Field changed: ${name} = ${value}`);
    
    setAdditionalAttributes({ ...additionalAttributes, [name]: value });
  };

  const years = Array.from({ length: new Date().getFullYear() - 1979 }, (_, i) => 1980 + i).reverse();

  return (
    <div className="truckForm">
      <div>
        <h3>
          Marka <span>*</span>
          <span className="tooltip-icon" title="Yük maşını istehsalçısı">ℹ️</span>
        </h3>
        <select 
          name="brandId" 
          onChange={(e) => {
            setSelectedBrand(e.target.value);
            handleChange(e);
          }}
          disabled={filteredBrands.length === 0}
          defaultValue=""
        >
          <option value="" disabled>
            {filteredBrands.length === 0 ? 'Yüklənir...' : 'Seçin'}
          </option>
          {filteredBrands.map((brand) => (
            <option key={brand.id} value={brand.id}>{brand.name}</option>
          ))}
        </select>
      </div>

      <div>
        <h3>
          Model <span>*</span>
          <span className="tooltip-icon" title="Yük maşını modeli">ℹ️</span>
        </h3>
        <select 
          name="modelId" 
          onChange={handleChange}
          disabled={filteredModels.length === 0}
          defaultValue=""
        >
          <option value="" disabled>
            {selectedBrand ? (filteredModels.length === 0 ? 'Yüklənir...' : 'Seçin') : 'Əvvəlcə marka seçin'}
          </option>
          {filteredModels.map((model) => (
            <option key={model.id} value={model.id}>{model.name}</option>
          ))}
        </select>
      </div>

      <div>
        <h3>
          İstehsal ili <span>*</span>
          <span className="tooltip-icon" title="Buraxılış ili">ℹ️</span>
        </h3>
        <select name="year" onChange={handleChange} defaultValue="" required>
          <option value="" disabled>Seçin</option>
          {years.map(year => (
            <option key={year} value={year}>{year}</option>
          ))}
        </select>
      </div>

      <div>
        <h3>
          Yanacaq növü <span>*</span>
          <span className="tooltip-icon" title="Mühərrik yanacağı">ℹ️</span>
        </h3>
        <select name="fuelTypeId" onChange={handleChange} defaultValue="" required>
          <option value="" disabled>Seçin</option>
          {fuelTypeData.map(f => <option key={f.id} value={f.id}>{f.name}</option>)}
        </select>
      </div>

      <div>
        <h3>
          Sürət qutusu <span>*</span>
          <span className="tooltip-icon" title="Transmissiya tipi">ℹ️</span>
        </h3>
        <select name="transmissionTypeId" onChange={handleChange} defaultValue="" required>
          <option value="" disabled>Seçin</option>
          {transmissionTypeData.map(t => <option key={t.id} value={t.id}>{t.name}</option>)}
        </select>
      </div>

      <div>
        <h3>
          Kabin növü <span>*</span>
          <span className="tooltip-icon" title="Sürücü kabini">ℹ️</span>
        </h3>
        <select name="cabinTypeId" onChange={handleChange} defaultValue="" required>
          <option value="" disabled>Seçin</option>
          {cabinTypeData.map(c => <option key={c.id} value={c.id}>{c.name}</option>)}
        </select>
      </div>

      <div>
        <h3>
          Mühərrik həcmi (L) <span>*</span>
          <span className="tooltip-icon" title="Engine displacement">ℹ️</span>
        </h3>
        <input 
          type="number" 
          name="engineVolume" 
          step="0.1" 
          placeholder="12.0"
          min="3"
          max="20"
          onChange={handleChange} 
          required
        />
      </div>

      <div>
        <h3>
          Mühərrik gücü (a.g.) <span>*</span>
          <span className="tooltip-icon" title="At gücü (HP)">ℹ️</span>
        </h3>
        <input 
          type="number" 
          name="enginePower" 
          placeholder="400"
          min="100"
          max="1000"
          onChange={handleChange} 
          required
        />
      </div>

      <div>
        <h3>
          Daşıma qabiliyyəti (ton) <span>*</span>
          <span className="tooltip-icon" title="Load capacity">ℹ️</span>
        </h3>
        <input 
          type="number" 
          step="0.1" 
          name="loadCapacity" 
          placeholder="20.0"
          min="1"
          max="100"
          onChange={handleChange} 
          required
        />
      </div>

      <div>
        <h3>
          Yürüş (km) <span>*</span>
          <span className="tooltip-icon" title="Ümumi yürüş">ℹ️</span>
        </h3>
        <input 
          type="number" 
          name="mileage" 
          placeholder="250000"
          min="0"
          onChange={handleChange} 
          required
        />
      </div>

      <div>
        <h3>
          Ötürücü <span>*</span>
          <span className="tooltip-icon" title="Drive type">ℹ️</span>
        </h3>
        <select name="driveType" onChange={handleChange} defaultValue="" required>
          <option value="" disabled>Seçin</option>
          <option value="Ön">Ön (Front)</option>
          <option value="Arxa">Arxa (Rear)</option>
          <option value="Tam">Tam (4x4 / 6x6)</option>
        </select>
      </div>

      <div>
        <h3>
          Platforma uzunluğu (m) <span>*</span>
          <span className="tooltip-icon" title="Yük platforması">ℹ️</span>
        </h3>
        <input 
          type="number" 
          step="0.1" 
          name="platformLength" 
          placeholder="6.0"
          min="2"
          max="15"
          onChange={handleChange} 
          required
        />
      </div>

      <div>
        <h3>
          Platforma eni (m) <span>*</span>
          <span className="tooltip-icon" title="Platform genişliyi">ℹ️</span>
        </h3>
        <input 
          type="number" 
          step="0.1" 
          name="platformWidth" 
          placeholder="2.5"
          min="1.5"
          max="4"
          onChange={handleChange} 
          required
        />
      </div>

      <div>
        <h3>
          Rəng <span>*</span>
          <span className="tooltip-icon" title="Kuzov rəngi">ℹ️</span>
        </h3>
        <input 
          type="text" 
          name="color" 
          placeholder="Ağ, Mavi, Qırmızı..."
          onChange={handleChange} 
          required
        />
      </div>

      <div>
        <h3>
          Yeni? <span>*</span>
          <span className="tooltip-icon" title="0 km yenidirmi?">ℹ️</span>
        </h3>
        <select name="isNew" onChange={handleChange} defaultValue="" required>
          <option value="" disabled>Seçin</option>
          <option value="true">Bəli (0 km)</option>
          <option value="false">Xeyr (İşlənmiş)</option>
        </select>
      </div>

      <div>
        <h3>
          Qəzalı olub? <span>*</span>
          <span className="tooltip-icon" title="Qəza keçirib?">ℹ️</span>
        </h3>
        <select name="isAccidented" onChange={handleChange} defaultValue="" required>
          <option value="" disabled>Seçin</option>
          <option value="true">Bəli ⚠️</option>
          <option value="false">Xeyr ✅</option>
        </select>
      </div>

      <div>
        <h3>
          VIN nömrəsi <span>*</span>
          <span className="tooltip-icon" title="17 simvollu unikal kod">ℹ️</span>
        </h3>
        <input 
          type="text" 
          name="vin" 
          placeholder="1HGBH41JXMN109186"
          maxLength={17}
          onChange={handleChange} 
          required
        />
      </div>

      <div>
        <h3>
          İstehsal bazarı <span>*</span>
          <span className="tooltip-icon" title="Hansı bazar üçün istehsal olunub">ℹ️</span>
        </h3>
        <select name="marketCountry" onChange={handleChange} defaultValue="" required>
          <option value="" disabled>Seçin</option>
          <option value="Avropa">Avropa</option>
          <option value="Amerika">Amerika (ABŞ)</option>
          <option value="Çin">Çin</option>
          <option value="Yaponiya">Yaponiya</option>
          <option value="Rusiya">Rusiya</option>
          <option value="Türkiyə">Türkiyə</option>
          <option value="Digər">Digər</option>
        </select>
      </div>
    </div>
  );
}

export default TruckForm;